module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921015334_T.ce48f006.jpg";